/* eslint-disable import/no-unresolved */
import { useReactiveVar, useLazyQuery, useQuery } from '@apollo/client';
import { GET_REPORT_LIST, GET_COMMON_REPORT_LIST } from 'Apollo/Queries/CrossReportValidation';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    showReportMenuVar, showCrossReportConfigVar, showConfigureDataSourceModalVar, moduleIdVar, dataSourceReportIdVar,
    leftNavigationItemsVar, showDataReconMenusVar, currentLeftMenuVar,
} from 'Apollo/config';
import { ModuleIdEnum, ModuleEnum } from 'constants';
import crossReportImg from 'assets/images/cross-report.svg';
import CrossReportValidation from '../components';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const CrossReportValidationContainer = () => {
    const history = useHistory();
    const [reportList, setReportList] = useState([]);
    const [crossReportList, setCrossReportList] = useState([]);
    const [primaryReportId, setPrimaryReportId] = useState(null);
    const [primaryPeriodOptions, setPrimaryPeriodOptions] = useState(null);
    const [crossValidatedReports, setCrossValidatedReports] = useState([]);
    const [showPrimaryPeriodSelect, setShowPrimaryPeriodSelect] = useState(false);
    const [primaryReportPeriod, setPrimaryReportPeriod] = useState(null);
    const [showPeriodSelectModal, setShowPeriodSelectModal] = useState(false);
    const [periodSelectOptions, setPeriodSelectOptions] = useState(null);
    const [selectedPrimaryReport, setSelectedPrimaryReport] = useState(null);
    const [selectedCrossReport, setSelectedCrossReport] = useState(null);
    const [selectedCrossReportsArray, setSelectedCrossReportsArray] = useState([]);
    const [primaryReport, setPrimaryReport] = useState(null);
    const [relatedReports, setRelatedReports] = useState(null);
    const showDataSourceModal = useReactiveVar(showConfigureDataSourceModalVar);

    const {
        data, loading, error, refetch,
    } = useQuery(GET_REPORT_LIST, {
        variables: {
            primaryReportId: null,
        },
        fetchPolicy: 'no-cache',
    });

    const [getCommonReportList, {
        data: commonReportData, loading: commonReportLoading, error: commonReportError,
        refetch: commonReportRefetch,
    }] = useLazyQuery(GET_COMMON_REPORT_LIST, {
        variables: {
            primaryReportId,
        },
        fetchPolicy: 'no-cache',
    });

    const onCrossReportSelection = (id, name, commonMdrm, periodData) => {
        const crossReport = { id, name, commonMdrm };
        setSelectedCrossReport(crossReport);
        if (!crossValidatedReports.includes(id) && periodData) {
            setPeriodSelectOptions(periodData);
            setShowPeriodSelectModal(true);
        } else {
            setShowPeriodSelectModal(false);
            setSelectedCrossReportsArray(prevState => {
                let temp = [...prevState];
                const found = temp.find(item => item.id === crossReport.id);
                if (!found) {
                    temp = temp.concat(crossReport);
                } else {
                    temp = temp.filter(item => item.id !== crossReport.id);
                }
                return temp;
            });
        }
    };

    const onCrossReportQuarterSelection = selectedData => {
        setSelectedCrossReportsArray(prevState => {
            let temp = [...prevState];
            temp = temp.concat(selectedData);
            return temp;
        });
    };

    const onConfigureDataSource = id => {
        showConfigureDataSourceModalVar(true);
        dataSourceReportIdVar(id);
    };

    useEffect(() => {
        moduleIdVar(ModuleIdEnum.CROSSREPORTVALIDATION);
        showCrossReportConfigVar(true);
        showDataReconMenusVar(false);
        showReportMenuVar(false);
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.CROSSREPORTVALIDATION);
    }, []);
    useEffect(() => {
        if (data && data.DQgetReportList) {
            setReportList(data.DQgetReportList);
        }
    }, [data]);

    useEffect(() => {
        if (primaryReportId) {
            setCrossValidatedReports([]);
            setRelatedReports(null);
            setSelectedCrossReportsArray([]);
            getCommonReportList();
            const selectedReport = reportList && reportList.filter(r => r.id === primaryReportId)[0];
            setPrimaryReport(selectedReport);
            setSelectedPrimaryReport({
                primaryReport: selectedReport,
            });
            setShowPrimaryPeriodSelect(selectedReport.hasPeriod);
            setPrimaryPeriodOptions(selectedReport.periodData);
        }
    }, [primaryReportId]);

    useEffect(() => {
        if (primaryReportPeriod) {
            const selectedPeriod = primaryPeriodOptions.filter(p => p.period === primaryReportPeriod)[0];
            setSelectedPrimaryReport({
                primaryReport,
                primaryReportPeriod: selectedPeriod,
            });
        }
    }, [primaryReportPeriod]);

    useEffect(() => {
        if (commonReportData && commonReportData.DQgetReportList) {
            setCrossReportList(commonReportData.DQgetReportList);
        }
    }, [commonReportData]);

    useEffect(() => {
        if (primaryReportId && crossValidatedReports.length > 0) {
            const crossReports = [];
            for (let i = 0; i < crossValidatedReports.length; i += 1) {
                const report = crossReportList.filter(cr => cr.id === crossValidatedReports[i])[0];
                crossReports.push(report);
            }
            setRelatedReports(crossReports);
        } else {
            setRelatedReports(null);
        }
    }, [crossValidatedReports]);

    useEffect(() => {
        if (!showDataSourceModal) {
            refetch();
            // commonReportRefetch();
        }
    }, [showDataSourceModal]);

    const breadcrumbItems = [
        {
            link: '',
            value: (
                <span
                    className="appkiticon icon-home-fill font-16"
                    onClick={
                        () => {
                            showReportMenuVar(false);
                            history.push('/');
                            showCrossReportConfigVar(false);
                            leftNavigationItemsVar([]);
                            moduleIdVar(null);
                        }
                    }
                    role="presentation"
                />
            ),
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text">Cross Report Validation</span>,
        },
    ];

    return (
        <CrossReportValidation
            loading={loading}
            reportList={reportList}
            breadcrumbItems={breadcrumbItems}
            primaryReportId={primaryReportId}
            setPrimaryReportId={setPrimaryReportId}
            crossValidatedReports={crossValidatedReports}
            setCrossValidatedReports={setCrossValidatedReports}
            showPrimaryPeriodSelect={showPrimaryPeriodSelect}
            setShowPrimaryPeriodSelect={setShowPrimaryPeriodSelect}
            primaryReportPeriod={primaryReportPeriod}
            setPrimaryReportPeriod={setPrimaryReportPeriod}
            primaryPeriodOptions={primaryPeriodOptions}
            onCrossReportSelection={onCrossReportSelection}
            showPeriodSelectModal={showPeriodSelectModal}
            setShowPeriodSelectModal={setShowPeriodSelectModal}
            selectedCrossReport={selectedCrossReport}
            periodSelectOptions={periodSelectOptions}
            onCrossReportQuarterSelection={onCrossReportQuarterSelection}
            selectedCrossReportsArray={selectedCrossReportsArray}
            crossReportList={crossReportList}
            primaryReport={primaryReport}
            relatedReports={relatedReports}
            selectedPrimaryReport={selectedPrimaryReport}
            showDataSourceModal={showDataSourceModal}
            onConfigureDataSource={onConfigureDataSource}
        />
    );
};

export default CrossReportValidationContainer;
